import isEqual from 'react-fast-compare';
import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey } from '../../utils/keys';
export const useAuthToken = (options) => {
    const { useQueryOptions, fields = 'default' } = options || {};
    const { client, config, onTokenUpdate } = useTribeClient();
    const authTokenKey = getAuthTokensKey();
    const { networkDomain } = config || {};
    return useQuery(authTokenKey, () => client.getTokens({ networkDomain }, fields), {
        isDataEqual: (o, n) => {
            const oldObj = getObj(o);
            const newObj = getObj(n);
            // let's only compare network, networkPublicInfo and member
            // const { network: on, networkPublicInfo: onp, member: om } = o
            // const { network: nn, networkPublicInfo: nnp, member: nm } = n
            // We should remove the pages before comparison because pages is weird :|
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            // const { pages: _op, ...oNetworkRest } = on
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            // const { pages: _np, ...nNetworkRest } = nn
            // const eq1 = isEqual(oNetworkRest, nNetworkRest)
            // const eq2 = isEqual(onp, nnp)
            // const eq3 = isEqual(om, nm)
            return isEqual(oldObj, newObj);
        },
        ...useQueryOptions,
        onSuccess: data => {
            client.setToken(data.accessToken);
            if (typeof onTokenUpdate === 'function') {
                onTokenUpdate(data);
            }
            if (typeof (useQueryOptions === null || useQueryOptions === void 0 ? void 0 : useQueryOptions.onSuccess) === 'function') {
                useQueryOptions.onSuccess(data);
            }
        },
    });
};
/** We cannot trust backend response being stable for example images are null sometimes and index of permission scopes are changing
 * So if we want to prevent from re-rendering we need to compare those we trust */
const getObj = obj => {
    var _a;
    return ({
        member: {
            name: obj === null || obj === void 0 ? void 0 : obj.member.name,
            email: obj === null || obj === void 0 ? void 0 : obj.member.email,
            emailStatus: obj === null || obj === void 0 ? void 0 : obj.member.emailStatus,
            status: obj === null || obj === void 0 ? void 0 : obj.member.status,
            username: obj === null || obj === void 0 ? void 0 : obj.member.username,
            tagline: obj === null || obj === void 0 ? void 0 : obj.member.tagline,
            fields: (_a = obj === null || obj === void 0 ? void 0 : obj.member) === null || _a === void 0 ? void 0 : _a.fields,
        },
        network: {
            name: obj === null || obj === void 0 ? void 0 : obj.network.name,
            memberCapacity: obj === null || obj === void 0 ? void 0 : obj.network.memberCapacity,
            memberCapacityDeclared: obj === null || obj === void 0 ? void 0 : obj.network.memberCapacityDeclared,
            membership: obj === null || obj === void 0 ? void 0 : obj.network.membership,
            membersCount: obj === null || obj === void 0 ? void 0 : obj.network.membersCount,
            status: obj === null || obj === void 0 ? void 0 : obj.network.status,
            tribeBranding: obj === null || obj === void 0 ? void 0 : obj.network.tribeBranding,
            visibility: obj === null || obj === void 0 ? void 0 : obj.network.visibility,
            whoCanInviteIds: obj === null || obj === void 0 ? void 0 : obj.network.whoCanInviteIds,
            activeTheme: obj === null || obj === void 0 ? void 0 : obj.network.activeTheme,
            authMemberProps: {
                context: obj === null || obj === void 0 ? void 0 : obj.network.authMemberProps.context,
                permissions: obj === null || obj === void 0 ? void 0 : obj.network.authMemberProps.permissions,
            },
            domain: obj === null || obj === void 0 ? void 0 : obj.network.domain,
            newDomain: obj === null || obj === void 0 ? void 0 : obj.network.newDomain,
            brandColor: obj === null || obj === void 0 ? void 0 : obj.network.brandColor,
            additionalSeatsCapacity: obj === null || obj === void 0 ? void 0 : obj.network.additionalSeatsCapacity,
            whoCanInvite: obj === null || obj === void 0 ? void 0 : obj.network.whoCanInvite,
            topNavigation: obj === null || obj === void 0 ? void 0 : obj.network.topNavigation,
            termsOfServiceUrl: obj === null || obj === void 0 ? void 0 : obj.network.termsOfServiceUrl,
            customSeoDetail: obj === null || obj === void 0 ? void 0 : obj.network.customSeoDetail,
        },
    });
};
//# sourceMappingURL=useAuthToken.js.map